export const formatNum = (num?: number) => {
  return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const ToString = (obj: any) => {
  let str = '';
  let keys = Object.keys(obj);
  for (let key of keys) {
    str = str + obj[key].toString() + ';';
  }
  return str;
};
